import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-content fade-in">
        <div className="hero-image-container">
          <div className="hero-image-placeholder">
            <img src="/IMG_0411.JPG" alt="Diba Mizan" />
          </div>
        </div>
        <h1 className="hero-title">Diba Mizan</h1>
        <p className="hero-subtitle">Architecture & Interior Design</p>
        <div className="hero-divider"></div>
        <p className="hero-description">
          Creating timeless spaces through minimalist design and thoughtful architecture
        </p>
      </div>
      <div className="scroll-indicator">
        <div className="scroll-line"></div>
      </div>
    </section>
  );
}

export default Hero;

